import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Column, FieldTableDto} from '@tj/tj-dmp-lib-api';
import {CompareService} from './compare.service';
import {Subscription} from 'rxjs';
import {DataCompare} from './data-compare.interface';

interface ColumnData {
    tableName: string;
    propertyName: string;
}

@Component({
    selector: 'dmp-data-compare',
    templateUrl: './data-compare.component.html',
    styleUrls: ['./data-compare.component.scss'],
    standalone: false
})
export class DataCompareComponent implements OnInit, OnDestroy, OnChanges {
    fields: FieldTableDto[] = null;
    datas: Array<DataCompare> = [];
    rowDatas: Array<any>;
    countRowDatas = 0;
    cols: ColumnData[] = [];

    // Liste des colonnes de la vue
    @Input() viewCols: Column[];
    // Liste des colonnes du préset
    @Input() presetCols: string[];
    @Output() changeSortField = new EventEmitter<string[]>();

    private sub: Subscription[] = [];

    constructor(private compareService: CompareService) {
    }

    ngOnDestroy(): void {
        this.sub.forEach(item => item.unsubscribe());
    }

    ngOnInit() {
        this.sub.push(this.compareService.dataObs.subscribe(datas => {
            this.datas = datas;
            this.rowDatas = [];
            datas.forEach(data => {
                this.rowDatas.push(data.data);
            });
            this.countRowDatas = this.rowDatas.length;
        }));
        this.sub.push(this.compareService.colsObs.subscribe(cols => {
            this.fields = cols;
        }));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.presetCols && this.presetCols.length > 0) {
            this.fillWithPresetCols();
        } else {
          this.fillWithCols();
        }
    }

    fillWithCols() {
        this.cols = this.viewCols.map(c => ({
            tableName: c.tableName,
            propertyName: c.propertyName
        }));
    }

    fillWithPresetCols() {
        this.cols = this.presetCols.map(c => {
            return {
                tableName: c.split('.')[0],
                propertyName: c.split('.')[1]
            };
        });
    }

    getFieldByCol(col: ColumnData) {
        return this.fields.find(f => f.table === col.tableName && f.code === col.propertyName);
    }

}
